import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { CheckOutlined } from '@material-ui/icons'
import React, { ChangeEvent } from 'react'
import { FilterProps } from 'react-table'

export interface FilterSelectProps {
    options: string[]
}

const FilterSelectText = ({ options }: FilterSelectProps) => {
    return ({
        column: { id, filterValue = [], setFilter },
    }: FilterProps<any>) => {
        const onSelectChange = (event: ChangeEvent<{ value: unknown }>) =>
            setFilter(event?.target.value)

        return (
            <Select
                multiple
                displayEmpty
                value={typeof filterValue === 'string' ? [] : filterValue}
                onChange={onSelectChange}
                input={
                    <Input
                        inputProps={{
                            className: `filter-select-${id}`,
                            style: {
                                fontSize: pxToRem(14),
                                padding: '8px 0 8px',
                            },
                        }}
                    />
                }
                renderValue={(selected: any) => {
                    return (selected as string[]).join(', ')
                }}
                style={{ width: 'inherit', height: '2.3em' }}
            >
                {options.map((option, idx) => (
                    <MenuItem
                        key={idx}
                        value={option}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                        data-testid={`filter-select-${option}`}
                    >
                        {option}
                        {window.location.pathname.includes('/bpm') && // this is so the change will only apply on the bpm tableview
                        filterValue.includes(option) ? (
                            <CheckOutlined
                                style={{
                                    height: '1.7rem',
                                    width: '1.7rem',
                                    marginLeft: '1rem',
                                }}
                            />
                        ) : (
                            <Typography></Typography>
                        )}
                    </MenuItem>
                ))}
            </Select>
        )
    }
}

export default FilterSelectText
